import { render, staticRenderFns } from "./Glass.vue?vue&type=template&id=1098be4a&scoped=true&"
var script = {}
import style0 from "./Glass.vue?vue&type=style&index=0&id=1098be4a&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1098be4a",
  null
  
)

export default component.exports